import {Component} from "react"
import {withTranslation} from 'react-i18next'
import {connect} from "react-redux"

import {InputWrapper, Select} from '@amzn/stencil-react-components/form'
import {Col, Row} from "@amzn/stencil-react-components/layout"
import {Text} from '@amzn/stencil-react-components/text'

import employeeService from '../../../services/Employee.service'
import {AWARD_VIEW_BY_OPTIONS} from "./common"

class AwardViewByDropdown extends Component {

  getAwardViewByOptions = (t) => {
    var options = [];
    options.push({value: AWARD_VIEW_BY_OPTIONS.AWARD_DATE, label: t('StockAwards.ViewByOptions.award')});
    options.push({value: AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR, label: t('StockAwards.ViewByOptions.calendar-year')});
    options.push({value: AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR, label: t('StockAwards.ViewByOptions.comp-year')});
    options.push({value: AWARD_VIEW_BY_OPTIONS.CUSTOM, label: t('StockAwards.ViewByOptions.custom')});

    if (employeeService.hasOptions(this.props.employee_awards)) {
      options.push({value: AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY, label: t('StockAwards.ViewByOptions.option')});
    }
    return options;
  };

  render() {
    const {t, selectedOptionValue, onChange, width} = this.props;

    const listOption = this.getAwardViewByOptions(t);
    const selectId = "award-view-by-dropdown";

    return (
      <InputWrapper id={selectId} labelText={t('StockAwards.ViewAwardsByHint')}>
        {inputProps => (
          <Col>
            <Select
              options={listOption}
              renderOption={option => (
                <Row alignItems="center" key={option.value}>
                  <Text>{option.label}</Text>
                </Row>
              )}
              renderNativeOption={option => option.label}
              value={listOption.find((element) => element.value == selectedOptionValue)}
              onChange={onChange}
              width={width}
              {...inputProps}
            />
          </Col>
        )}
      </InputWrapper>
    );
  }
}

const mapState = state => ({
  employee_awards: state.employee.awards
});

export default connect(mapState)(withTranslation('translationsV2')(AwardViewByDropdown));
